import { DateTime } from 'luxon';

import { StoreFieldsFragment } from '../../graphql';
import { StoreOpenStatus } from '../../types';
import { getOpenStatusAtMoment } from '../getOpenStatusAtMoment';
import { getStoreHours } from '../getStoreHours';

export const getStoreOpenStatus = (
	store: StoreFieldsFragment,
	now: DateTime
): StoreOpenStatus => {
	const hours = getStoreHours(store, now);
	if (store.monThruThursClose === store.monThruThursOpen) {
		return 'CLOSED';
	}
	return getOpenStatusAtMoment(hours, now);
};
